import { render, staticRenderFns } from "./EmailPartnerTariffs.vue?vue&type=template&id=3e9f7979&"
import script from "./EmailPartnerTariffs.vue?vue&type=script&lang=ts&"
export * from "./EmailPartnerTariffs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports